import cloneDeep from 'lodash/fp/cloneDeep'
import {
  VALIDATE_CONTACT_ADVISER_CONTACT,
  SET_CONTACT_ADVISER_NAME,
  SET_CONTACT_ADVISER_EMAIL,
  SET_CONTACT_ADVISER_CONTACTNUM,
  SET_CONTACT_ADVISER_COMMENT,
  SUBMITTED_CONTACT_ADVISER_CONTACT,
  SUBMITTING_CONTACT_ADVISER_CONTACT,
  SET_CONTACT_ADVISER_RESPONSE_STATUS,
  FETCHING_TOTAL_EMAILS_SENT,
  FETCHED_TOTAL_EMAILS_SENT,
  SUBMITTING_SENT_EMAIL,
  SUBMITTED_SENT_EMAIL,
  LIMIT_EXCEEDED,
  CLEAR_CONTACT_ADVISER_DETAILS
} from './ContactAnAdviserContainerActions'

const initialState = {
  submittedStatus: 'PENDING',
  enteredName: '',
  enteredNumber: '',
  enteredEmail: '',
  enteredComment: '',
  totalEmailsSent: 0,
  fetchingTotalEmailsSent: false,
  submittingSentEmail: false,
  submittedSentEmailResponse: {},
  isInvalid: {
    formIsValid: false,
    NameContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    NumberContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    EmailContainer: {
      isInvalid: false,
      message: null,
      valid: false
    },
    CommentContainer: {
      isInvalid: false,
      message: null,
      valid: true
    }
  }
}

export default function (state = initialState, action) {
  var oldState = state
  var newState = cloneDeep(oldState)

  function isFormValid (currentState) {
    return currentState.isInvalid.NameContainer.valid &&
      currentState.isInvalid.NumberContainer.valid &&
      currentState.isInvalid.EmailContainer.valid
  }

  switch (action.type) {

    case VALIDATE_CONTACT_ADVISER_CONTACT: {
      if (action.specificComponent == null) {
        action.specificComponent = 'All'
      }
      if ((action.specificComponent === 'name') || (action.specificComponent === 'All')) {
        if (newState.enteredName === '') {
          newState.isInvalid.NameContainer = {
            isInvalid: true,
            message: 'Please enter a Contact Name',
            valid: false
          }
        } else {
          newState.isInvalid.NameContainer = {
            isInvalid: false,
            message: null,
            valid: true
          }
        }
      }

      if ((action.specificComponent === 'contactNumber') || (action.specificComponent === 'All')) {
        if (newState.enteredNumber === '') {
          newState.isInvalid.NumberContainer = {
            isInvalid: true,
            message: 'Please enter a valid Contact Number',
            valid: false
          }
        } else {
          newState.isInvalid.NumberContainer = {
            isInvalid: false,
            message: null,
            valid: true
          }
        }
      }

      if ((action.specificComponent === 'email') || (action.specificComponent === 'All')) {
        if (newState.enteredEmail === '') {
          newState.isInvalid.EmailContainer = {
            isInvalid: true,
            message: 'Please enter a valid Email',
            valid: false
          }
        } else {
          newState.isInvalid.EmailContainer = {
            isInvalid: false,
            message: null,
            valid: true
          }
        }
      }
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    }

    case SET_CONTACT_ADVISER_NAME: {
      if (action.name === '') {
        newState.isInvalid.NameContainer.isInvalid = true
        newState.isInvalid.NameContainer.message = 'Please enter a Name'
        newState.isInvalid.NameContainer.valid = false
      } else {
        newState.isInvalid.NameContainer.isInvalid = false
        newState.isInvalid.NameContainer.message = null
        newState.isInvalid.NameContainer.valid = true
      }
      newState.enteredName = action.name
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    }

    case SET_CONTACT_ADVISER_CONTACTNUM: {
      newState.isInvalid.NumberContainer.isInvalid = action.validationResult.isInvalid
      newState.isInvalid.NumberContainer.message = action.validationResult.message
      newState.isInvalid.NumberContainer.valid = action.validationResult.valid
      newState.enteredNumber = action.number
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    }

    case SET_CONTACT_ADVISER_EMAIL: {
      newState.isInvalid.EmailContainer.isInvalid = action.validationResult.isInvalid
      newState.isInvalid.EmailContainer.message = action.validationResult.message
      newState.isInvalid.EmailContainer.valid = action.validationResult.valid
      newState.isInvalid.EmailContainer.pristine = action.validationResult.pristine
      newState.enteredEmail = action.value
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    }

    case SET_CONTACT_ADVISER_COMMENT: {
      newState.isInvalid.CommentContainer.isInvalid = false
      newState.isInvalid.CommentContainer.message = null
      newState.isInvalid.CommentContainer.valid = true
      newState.enteredComment = action.comment
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    }

    case SUBMITTING_CONTACT_ADVISER_CONTACT: {
      newState.submitting = true
      return newState
    }
    case SET_CONTACT_ADVISER_RESPONSE_STATUS: {
      newState.submittedStatus = action.responseStatus
      return newState
    }

    case SUBMITTED_CONTACT_ADVISER_CONTACT: {
      newState = cloneDeep(initialState)
      newState.isInvalid = cloneDeep(initialState.isInvalid)
      newState.submittedStatus = 'SUBMITTED'
      newState.isInvalid.formIsValid = isFormValid(newState)

      return newState
    }

    case FETCHING_TOTAL_EMAILS_SENT: {
      newState.fetchingTotalEmailsSent = true
      return newState
    }

    case FETCHED_TOTAL_EMAILS_SENT: {
      newState.fetchingTotalEmailsSent = false
      newState.totalEmailsSent = action.payload
      return newState
    }

    case SUBMITTING_SENT_EMAIL: {
      newState.submittingSentEmail = true
      return newState
    }

    case SUBMITTED_SENT_EMAIL: {
      newState.submittingSentEmail = false
      newState.submittedSentEmailResponse = action.payload
      return newState
    }

    case CLEAR_CONTACT_ADVISER_DETAILS: {
      return {
        ...state,
        enteredName: '',
        enteredNumber: '',
        enteredEmail: '',
        enteredComment: '',
        isInvalid: {
          formIsValid: false,
          NameContainer: { isInvalid: false, message: null, valid: false },
          NumberContainer: { isInvalid: false, message: null, valid: false },
          EmailContainer: { isInvalid: false, message: null, valid: false },
          CommentContainer: { isInvalid: false, message: null, valid: true }
        }
      }
    }

    case LIMIT_EXCEEDED: {
      newState.submittedStatus = 'LIMIT_EXCEEDED'
      return newState
    }

  }
  return state
}
